import { render, staticRenderFns } from "./GBPhotoAlbumSelectList.vue?vue&type=template&id=34d8de60&"
import script from "./GBPhotoAlbumSelectList.vue?vue&type=script&lang=js&"
export * from "./GBPhotoAlbumSelectList.vue?vue&type=script&lang=js&"
import style0 from "./GBPhotoAlbumSelectList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports